// * Bootstrap libraries
import './_bootstrap';
import { initStickyHeader } from './_sticky-header';

// * Any other global site-wide JavaScript should be placed below.

// Initialize sticky header
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initStickyHeader);
} else {
  initStickyHeader();
}
